<script lang="ts" setup>
import type { Toast } from '~/types/ui'

const toasts = useState<Array<Toast>>('toasts', () => [])
</script>

<template>
  <Teleport to="body">
    <div class="fixed right-4 top-4 isolate z-[100] space-y-4">
      <ToasterToast
        v-for="toast in toasts"
        :key="toast.id"
        v-bind="{ ...toast }"
      />
    </div>
  </Teleport>
</template>
